import React from "react";
import styled from "styled-components";
import { Primary } from "@ui/components/containers/primary";
import { Row, row } from "@ui/components/layout";
import { mobile } from "@ui/styles/utils";

interface StepIndicatorProps extends React.HTMLAttributes<HTMLDivElement> {
	steps: number;
	currentStep: number;
}
export const StepIndicator: React.FC<StepIndicatorProps> = ({ steps, currentStep, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			{[...Array(steps)].map((_, i) => (
				<Row key={i} gap={0} align="center">
					<Bubble active={currentStep >= i}>
						<Primary>
							<b>{i + 1}</b>
						</Primary>
					</Bubble>
					{i !== steps - 1 && <Wire active={currentStep >= i} />}
				</Row>
			))}
		</Container>
	);
};

const Container = styled.div`
	${row(0, "flex-start", "center")};
`;

const Bubble = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "active",
})<{ active: boolean }>`
	width: 50px;
	height: 50px;
	border-radius: 25px;
	background-color: ${({ theme, active }) => (active ? theme.colors.secondary : theme.colors.white)};
	border: solid 1px ${({ theme, active }) => (active ? theme.colors.secondary : theme.colors.secondaryLight)};
	${row(0, "center", "center")};
	* {
		color: ${({ theme, active }) => (active ? theme.colors.white : theme.colors.textPrimary)};
	}
`;

const Wire = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "active",
})<{ active: boolean }>`
	height: 2px;
	width: 108px;
	@media ${mobile} {
		width: 80px;
	}
	background-color: ${({ theme, active }) => (active ? theme.colors.secondary : theme.colors.secondaryLight)};
`;
